/**
 * The invoice list's filter vocabulary and its PDF / spreadsheet exports - the
 * frontend half of `GET /accounts/:accountId/invoices` and
 * `/invoices/export.pdf|.xlsx` (`apps/backend/platform/src/api/routes/`).
 *
 * `invoiceListFilterQuery` is the one place these filters become a querystring.
 * The list and both downloads all call it, so an export can never select
 * different rows from the screen it was started on.
 */
import { downloadFile } from '../client.js';
/** The shared filter and sort params as a querystring builder. */
export function invoiceListFilterQuery(params) {
    const qs = new URLSearchParams();
    for (const s of params?.status ?? [])
        qs.append('status', s);
    if (params?.includeArchived)
        qs.set('includeArchived', 'true');
    if (params?.search)
        qs.set('search', params.search);
    if (params?.clientId)
        qs.set('clientId', params.clientId);
    if (params?.dateFrom)
        qs.set('dateFrom', params.dateFrom);
    if (params?.dateTo)
        qs.set('dateTo', params.dateTo);
    if (params?.sortBy)
        qs.set('sortBy', params.sortBy);
    if (params?.sortDirection)
        qs.set('sortDirection', params.sortDirection);
    return qs;
}
function exportPath(accountId, extension, filters) {
    const query = invoiceListFilterQuery(filters).toString();
    return `/accounts/${accountId}/invoices/export.${extension}${query ? `?${query}` : ''}`;
}
export function downloadInvoiceListPdf(accountId, filters) {
    return downloadFile(exportPath(accountId, 'pdf', filters), 'invoices.pdf');
}
export function downloadInvoiceListXlsx(accountId, filters) {
    return downloadFile(exportPath(accountId, 'xlsx', filters), 'invoices.xlsx');
}
